<template>
  <div class="wgt-business container">
    <div class="module-header">
      <div class="head">
        <h2 class="head-title">
          <div class="title">
            <span style="margin-right: 5px;">
              <svg-icon name="circle"/>
            </span>
            <router-link :to="{path: 'circle'}">社区</router-link>
          </div>
        </h2>
      </div>
    </div>
    <div class="business-list" v-loading="dataLoading">
      <el-empty v-if="!(list && list.length)"/>
      <div v-else class="business-item" v-for="item in list" :key="item.id">
        <router-link :to="{path: '/circle/detail', query: {id: item.id}}" target="_blank" class="link">
          <img v-if="item.image" :src="item.image" alt="" class="avatar">
          <svg v-else t="1616121214661" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2652" width="92" height="92"><path d="M512 966.206061c-61.155556 0-120.50101-12.024242-176.355556-35.684849-53.915152-22.884848-102.4-55.466667-144.032323-97.09899S117.268687 743.434343 94.513131 689.519192c-23.660606-55.854545-35.684848-115.2-35.684848-176.355556s12.024242-120.50101 35.684848-176.355555C117.268687 282.763636 149.979798 234.278788 191.612121 192.646465c41.632323-41.632323 90.117172-74.343434 144.032323-97.09899 55.854545-23.660606 115.2-35.684848 176.355556-35.684849 61.155556 0 120.50101 12.024242 176.355556 35.684849 53.915152 22.884848 102.4 55.466667 144.032323 97.09899 41.632323 41.632323 74.343434 90.117172 97.09899 144.032323 23.660606 55.854545 35.684848 115.2 35.684848 176.355555s-12.024242 120.50101-35.684848 176.355556c-22.884848 53.915152-55.466667 102.4-97.09899 144.032323s-90.117172 74.343434-144.032323 97.09899c-55.854545 23.789899-115.2 35.684848-176.355556 35.684849z m0-859.79798C287.806061 106.408081 105.373737 288.840404 105.373737 513.034343S287.806061 919.660606 512 919.660606s406.626263-182.432323 406.626263-406.626263S736.193939 106.408081 512 106.408081z" fill="" p-id="2653"></path><path d="M512 813.252525c-78.092929 0-151.40202-30.383838-206.610101-85.591919C250.181818 672.581818 219.79798 599.143434 219.79798 521.050505c0-77.963636 30.383838-151.272727 85.462626-206.480808 55.078788-55.208081 128.258586-85.591919 206.222222-85.721212 12.8 0 23.272727 10.343434 23.272728 23.272727 0 12.8-10.343434 23.272727-23.272728 23.272727-135.111111 0.258586-245.139394 110.545455-245.139394 245.656566 0 135.49899 110.157576 245.656566 245.656566 245.656566s245.656566-110.157576 245.656566-245.656566v-0.517172c0-12.8 10.472727-23.272727 23.272727-23.272727s23.272727 10.472727 23.272727 23.272727v0.517172c0 78.092929-30.383838 151.40202-85.591919 206.610101C663.40202 782.868687 590.092929 813.252525 512 813.252525z" fill="" p-id="2654"></path><path d="M512 640.129293h-0.387879c-12.8-0.129293-23.143434-10.472727-23.143434-23.272727s10.472727-23.272727 23.272727-23.272728h0.258586c43.70101 0 79.256566-35.684848 79.256566-79.385858 0-43.830303-35.555556-79.385859-79.385859-79.385859s-79.385859 35.555556-79.385859 79.385859c0 1.939394 0.129293 3.878788 0.258586 5.818182 0.905051 12.8-8.662626 23.919192-21.591919 24.953535-12.8 0.905051-23.919192-8.662626-24.953535-21.591919-0.258586-3.10303-0.387879-6.206061-0.387879-9.179798 0-69.430303 56.50101-125.931313 125.931313-125.931313s125.931313 56.50101 125.931313 125.931313-56.242424 125.931313-125.672727 125.931313z m-0.129293 0z" fill="" p-id="2655"></path></svg>
          <div class="name">{{item.name}}</div>
        </router-link>
        <div class="statics">
          <span class="reply-num">{{numFormat(item.dynamicNum || 0)}}动态</span>
          <span class="point"></span>
          <span class="thumb-num">{{numFormat(item.memberNum || 0)}}成员</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ref} from "vue"
import { getCircleHotList } from "@/api/circle"
import SvgIcon from "@/components/SvgIcon";
export default {
  name: "customCircle",
  components: {
    SvgIcon
  },
  setup() {
    const dataLoading = ref(true)
    const list = ref([])
    getCircleHotList({size: 14, current: 1}, res => {
      dataLoading.value = false
      list.value = res.list
    }).catch(() => {
      dataLoading.value = false
    })
    const numFormat = (num) => {
      if (num > 10000) {
        return parseFloat(num / 10000).toFixed(1) + "w"
      }
      return num;
    }
    return {
      dataLoading,
      list,
      numFormat
    }
  }
}
</script>

<style scoped lang="scss">
.wgt-business {
  margin: 0 0 20px;
  box-sizing: border-box;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  .module-header {
    display: flex;
    margin-bottom: 10px;
    .head {
      line-height: 40px;
      height: 40px;
      display: inline-block;
      &:before {
        content: " ";
        display: table;
      }
      .head-title {
        margin-top: 20px;
        margin-left: 10px;
        font-size: 20px;
        float: left;
        margin-right: 12px;
        transform: translateY(-50%);
        color: #222;
        a {
          color: #222;
        }
      }
      &:after {
        clear: both;
        content: " ";
        display: table;
      }
    }
  }
  .business-list {
    margin: 0 10px;
    text-align: center;
    border-radius: 4px;
    border: 1px solid #f2f2f2;
    background: #fff;
    .business-item {
      display: inline-block;
      background: #fff;
      padding: 30px 0;
      width: 14.285714%;
      .link {
        display: block;
        text-decoration: none;
        .avatar {
          display: block;
          width: 90px;
          height: 90px;
          margin: 0 auto 10px;
          border: 1px solid #e7e7e7;
          border-radius: 4px;
        }
        .name {
          margin-bottom: 10px;
          font-size: 14px;
          color: #333;
          text-align: center;
          line-height: 16px;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          width: 100%;
        }
      }
      .statics {
        font-size: 12px;
        color: #9D9D9D;
        line-height: 12px;
        text-align: center;
        .reply-num, .thumb-num {
          margin-right: 3px;
          vertical-align: middle;
        }
        .point {
          display: inline-block;
          width: 2px;
          height: 2px;
          margin-right: 3px;
          border-radius: 2px;
          vertical-align: middle;
          background: #9D9D9D;
        }
      }
      &:hover {
        .name {
          color: $--color-primary;
        }
      }
    }
  }
}
</style>
